<div class="cmp-container learnspace-theme" *ngIf="hub">
  <page-header [title]="hub.title" [backgroundUrl]="'/assets/wonda/background2_ld.jpg'" ></page-header>

  <div class="page-container">
    <mat-tab-group vertical [selectedIndex]="getSelectedIndex()" (selectedIndexChange)="onSelectedIndexChange($event)" >

      <mat-tab label="Overview" color="white" class="learnspace-theme">
        <ng-template matTabContent>
          <hub-overview [hub]="hub" [date_from]="date_from" [date_to]="date_to"></hub-overview>
          <!-- <course-stats [course]="course" [quizzes]="quizzes" [date_from]="date_from" [date_to]="date_to" (navigateTab)="onNavigateTab($event)"></course-stats> -->
        </ng-template>
      </mat-tab>
      <mat-tab [label]="'By ' + (hub.mode | courseLabel:true | titlecase)" color="white" class="learnspace-theme">
        <ng-template matTabContent>
          <hub-usage [hub]="hub" [date_from]="date_from" [date_to]="date_to"></hub-usage>
          <!-- <visitors-stats [course]="course" [date_from]="date_from" [date_to]="date_to" [search]="activeUserSearch"  (onSearch)="onNavigateTab($event)"></visitors-stats> -->
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <!-- 


    
     -->
  </div>
  
  </div>
  